export default __webpack_public_path__ + "static/winter-holidays_5-d80c6fdf2e01396801f5272790f36a8f.png";